import {BarChartRow} from "../locations/marketing/charts/BarChart";
import {ACCESSES_COLOR, NOT_ACCESSES_COLOR} from "../users/UserManagement";
import {LegendItem} from "../components/charts/Legend";

export interface UsersAccessInADay {
    date: string,
    dateString: string,
    localDateString: string,
    users: number
}

export interface UsersAccessPerADay {
    usersLogging: UsersAccessInADay[],
    usersNotLogging: number
}

export interface ChartTexts {
    usersLogging: string,
    usersLoggingByDayTitle: string,
    noDataAvailable: string,
    checkFiltersMessage: string,
    errorTitle: string,
    tryAgainLaterMessage: string
}

export const createBarChartData = (daysActivities: UsersAccessInADay[]): BarChartRow[] => {
    return daysActivities.map((usersAccess) => {
        return {
            color: usersAccess.users > 0 ? ACCESSES_COLOR : NOT_ACCESSES_COLOR,
            value: usersAccess.users,
            name: usersAccess.dateString
        }
    })
}

export const getLegend = (usersLoggingText): LegendItem [] => {
    return [{
        color: ACCESSES_COLOR,
        name: usersLoggingText,
        value: 0,
    }]
}